import React, { PropTypes } from 'react';
import ReactDOM from 'react-dom';

import GoogleMapReact from 'google-map-react';

const defaultProps = {
    zoom: 18
};

const API_KEY = 'AIzaSyBieaitf8vDRHaAc5rE67IAS9Y0--VpP-0';

export default class LocationMap extends React.Component {
    render() {
        let center = {
            lat: this.props.latitude,
            lng: this.props.longitude
        };

        return (
            <div className="map-container hidden-xs">
                <GoogleMapReact
                    apiKey={API_KEY}
                    defaultCenter={center}
                    defaultZoom={defaultProps.zoom}>
                    <Marker
                        lat={this.props.latitude}
                        lng={this.props.longitude} />
                </GoogleMapReact>
            </div>
        );
    }
}

function Marker(props) {
    return (
        <div className="map-marker">
            <img className="marker" src="/images/components/location/location-pin.svg" alt="location-pin"></img>
        </div>
    );
}

[...document.getElementsByClassName('js-location-map')].forEach((elem) => {
    let lat = +elem.dataset.latitude;
    let lon = +elem.dataset.longitude;

    ReactDOM.render(
        <LocationMap
            latitude={lat}
            longitude={lon}
        />, elem);
});


// WEBPACK FOOTER //
// ./Src/Components/Location/LocationMap/LocationMap.jsx